"use client";

import { Box, Typography, Button, Container, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { ScribbleBadge } from "./ScribbleBadge";
import pattern1 from "../assets/pattern1.svg";

interface HeroSectionProps {
  onBecomePartner: () => void;
}

export default function HeroSection({ onBecomePartner }: HeroSectionProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleLearnMore = () => {
    const section = document.getElementById("how-it-works");
    section?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        py: { xs: 6, md: 15 },
        textAlign: "center",
        // backgroundColor: "background.paper",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors.primary[900],
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${pattern1})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "-5px 40px",
          backgroundSize: "600px",
          opacity: 0.02,
          pointerEvents: "none",
          zIndex: 0,
        },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3.2rem" },
            fontWeight: 800,
            mb: 2,
            color: "#724E41",
            lineHeight: 1.2,
          }}
        >
          Partner With Muzukuru
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem" },
            color: "#4B5563",
            mb: 4,
            maxWidth: 700,
            mx: "auto",
            lineHeight: 1.7,
          }}
        >
          Offer families professional funeral live streaming while your
          organisation earns <ScribbleBadge>10% commission</ScribbleBadge> on
          every completed booking.
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={onBecomePartner}
            sx={{
              backgroundColor: "#6D4C41",
              px: 4,
              py: 1.5,
              borderRadius: "26px",
              fontSize: "0.95rem",
              "&:hover": {
                backgroundColor: "#4E342E",
              },
            }}
          >
            Become a Partner
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={handleLearnMore}
            sx={{
              borderColor: "#6D4C41",
              color: "#6D4C41",
              px: 4,
              py: 1.5,
              borderRadius: "26px",
              fontSize: "0.95rem",
              "&:hover": {
                borderColor: "#4E342E",
                backgroundColor: "rgba(109,76,65,0.05)",
              },
            }}
          >
            Learn more
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
